import { createAction } from '@saucelabs/sl-util-redux';

import * as constants from './constants';

export const initialized = createAction(constants.INITIALIZED);
export const cleanup = createAction(constants.CLEANUP);
export const updateLastUsedDC = createAction(constants.UPDATE_LAST_USED_DC);
